import type { RewardsSpendingRulesRedeemBody } from "@apps/rewards/modules/SpendingRules/types";
import type { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { REWARDS_SDK_METHODS } from "../constants";

class RedeemRewardSdkMethodPayload implements SdkMethodPayloadInterface {
    public readonly methodName: REWARDS_SDK_METHODS.REDEEM_REWARD;

    constructor(
        public readonly body: RewardsSpendingRulesRedeemBody,
        public readonly onSuccess: () => void,
        public readonly onError: (error: Error) => void
    ) {
        this.methodName = REWARDS_SDK_METHODS.REDEEM_REWARD;
        this.body = body;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default RedeemRewardSdkMethodPayload;
